import assign from 'object-assign';
import FluxEventEmitter from '../FluxEventEmitter';

const interactiveContent = {};
const eventConfigs = {};

const Events = {
	INTERACTIVE_CONTENT_LOADED: 'interactiveLoaded',
	EVENT_CONFIG_LOADED: 'eventConfigLoaded',
};

/**
 * @param {String} date
 * @param {Boolean} isMobile
 * @return {string}
 */
function getConfigKey(date, isMobile = false) {
	return 'd:' + JSON.stringify(date) + ';isMobile:' + JSON.stringify(isMobile);
}

/**
 * @param {Number} limit
 * @param {String} order
 * @return {string}
 */
function getKey(limit, order) {
	return 'l:' + limit + ';order:' + order;
}

const DailyBonusStore = assign({}, FluxEventEmitter.prototype, {
	setInteractiveContent(limit, order, content) {
		interactiveContent[getKey(limit, order)] = content;
		DailyBonusStore.emit(Events.INTERACTIVE_CONTENT_LOADED, limit, order);
	},

	setEventConfig(date, isMobile = false, event = null) {
		eventConfigs[getConfigKey(date, isMobile)] = event;
		DailyBonusStore.emit(Events.EVENT_CONFIG_LOADED, date, isMobile);
	},

	/**
	 * @param {Function} callback
	 */
	addInteractiveContentLoadListener(callback) {
		this.on(Events.INTERACTIVE_CONTENT_LOADED, callback);
	},

	/**
	 * @param {Function} callback
	 */
	removeInteractiveContentLoadListener(callback) {
		this.removeListener(Events.INTERACTIVE_CONTENT_LOADED, callback);
	},

	/**
	 * @param {Number} limit
	 * @param {String} order
	 * @return {Array}
	 */
	getInteractiveContent(limit, order) {
		const key = getKey(limit, order);
		return Object.hasOwn(interactiveContent, key) ? interactiveContent[key] : [];
	},

	/**
	 * @param {Function} callback
	 */
	addEventConfigLoadedListener(callback) {
		this.on(Events.EVENT_CONFIG_LOADED, callback);
	},
	/**
	 * @param {Function} callback
	 */
	removeEventConfigLoadedListener(callback) {
		this.removeListener(Events.EVENT_CONFIG_LOADED, callback);
	},
	/**
	 * @param {String} date
	 * @param {Boolean} isMobile
	 * @return {Object}
	 */
	getEventConfig(date = null, isMobile = false) {
		const key = getConfigKey(date, isMobile);
		return Object.hasOwn(eventConfigs, key) ? eventConfigs[key] : null;
	},
});

export default DailyBonusStore;
